<template>
  <div style="width: 100%; height: 86vh; display: flex; position: relative;" class="main_container">
    <!--左边-->
    <div class="left-part">
      <!--左上-->
      <div class="left-part-top"  :class="getRightFold?'':'left-part-top-move'">
        <div
          class="left-part-top_item"
        >
          <div class="title">合作社总量(家)</div>
          <div
            class="num"
            :data-content="numberSeparatorCompute(headerStatics.cooperationCount || 0)"
          >
            {{ (headerStatics.cooperationCount || 0) | numberSeparator }}
          </div>
        </div>
        <div
          class="left-part-top_item"
        >
          <div class="title">入社农机数量(台)</div>
          <div
            class="num"
            :data-content="numberSeparatorCompute(headerStatics.joinVehicleCount || 0)"
          >
            {{ (headerStatics.joinVehicleCount || 0) | numberSeparator }}
          </div>
        </div>
        <div
          class="left-part-top_item"
        >
          <div class="title">入社人数(人)</div>
          <div
            class="num"
            :data-content="numberSeparatorCompute(headerStatics.joinUserCount || 0)"
          >
            {{ (headerStatics.joinUserCount || 0) | numberSeparator }}
          </div>
        </div>
        <div
          class="left-part-top_item"
        >
          <div class="title">省级服务中心(家)</div>
          <div
            class="num"
            :data-content="numberSeparatorCompute(headerStatics.provinceServerCount || 0)"
          >
            {{ (headerStatics.provinceServerCount || 0) | numberSeparator }}
          </div>
        </div>
        <div
          class="left-part-top_item"
        >
          <div class="title">市级服务中心(家)</div>
          <div
            class="num"
            :data-content="numberSeparatorCompute(headerStatics.cityServerCount || 0)"
          >
            {{ (headerStatics.cityServerCount || 0) | numberSeparator }}
          </div>
        </div>
        <div
          class="left-part-top_item"
        >
          <div class="title">县区级服务中心(家)</div>
          <div
            class="num"
            :data-content="numberSeparatorCompute(headerStatics.countyServerCount || 0)"
          >
            {{ (headerStatics.countyServerCount || 0) | numberSeparator }}
          </div>
        </div>
      </div>
        <!--左左-->
        <div class="left-part-left left_item_list">
        <div class="main_list animate__animated">
          <div v-for="(item, index) in leftTypeList" @click="selectType(item, leftTypeList, 'left')">
            <img
              :class="item.className"
              :key="index"
              :src="item.active ? item.iconUrl : item.iconUrl_"
              alt=""
              srcset=""
            />
          </div>
        </div>
      </div>
      <!--左下-->
      <div class="left-part-bottom bottom_item_list">
        <div class="bootom_list_box animate__animated" :class="getRightFold?'':'left-part-bottom-move'">
          <div v-for="(item, index) in rightTypeList" @click="selectType(item, rightTypeList, 'right')">
            <img
              :key="index"
              :class="item.className"
              :src="item.active ? item.iconUrl : item.iconUrl_"
              alt=""
              srcset=""
            />
          </div>
        </div>
      </div>

      <div class="map_container">
        <map-model
          ref="mapModel"
          @featureClick="featureClick"
          :vehicleTypeCode="currentVehicleTypeCodes"
          :commonParams="commonParams"
        ></map-model>
      </div>
      <div></div>
    </div>

    <!-- 中间合作社来源 -->
    <!-- <div class="drc_select cooperatvie_select" :class="getRightFold?'':'drc_select-move'">
      <el-select
        v-model.trim="cooperativeSource"
        placeholder=""
        class="work_select"
        popper-class="drc_select_popper"
      >
        <el-option
          class="option_class"
          v-for="item in cooperativeSourceOptions"
          :key="item.dictValue"
          :label="item.dictLabel"
          :value="item.dictValue"
        ></el-option>
      </el-select>
    </div> -->

    <!--右边-->
    <div class="right-part" :class="getRightFold?'':'right-part-close'">
      <!-- <div class="right-part-top" style="height: 25vh">
        <div class="currency-title-long">
          <div class="title">
            <span>各类型合作社分布数量统计</span>
          </div>
        </div>
        <rightTopChart v-if="rightTopChart.regionCooperativeList && rightTopChart.regionCooperativeList.length>0" :chartData="rightTopChart"></rightTopChart>
        <div v-else class="empty_panel"></div>
      </div> -->

      <div class="right-part-bottom" style="height: 86vh">
        <div class="right-part-bottom-left">
          <div  class="right-part-bottom-left-top"  style="height: 38vh">
            <div class="currency-title">
              <div class="title">
                <span>烘干中心/应急服务队数量统计</span>
              </div>
            </div>
            <div class="bottom-left-top-content">
              <div class="bottom-left-top-content-item">
                <div class="title-num-box">
                  <div class="title-num-box-item">
                    <div class="title">烘干中心总数量</div>
                    <div class="num" :data-content="numberSeparatorCompute(rightCenterData.dryingCount || 0)">{{ (rightCenterData.dryingCount || 0) | numberSeparator}}</div>
                  </div>
                  <div class="title-num-box-item">
                    <div class="title">日烘干能力(吨)</div>
                    <div class="num" :data-content="numberSeparatorCompute(rightCenterData.dryingCapability || 0)">{{ (rightCenterData.dryingCapability || 0) | numberSeparator}}</div>
                  </div>
                </div>
              </div>
              <div  class="bottom-left-top-content-item">
                <div class="title-num-box">
                  <div class="title-num-box-item">
                    <div class="title">应急服务队总数量</div>
                    <div class="num" :data-content="numberSeparatorCompute(rightCenterData.emergencyCount || 0)">{{ (rightCenterData.emergencyCount || 0) | numberSeparator}}</div>
                  </div>
                  <div class="title-num-box-item">
                    <div class="title">主要装备总数量(台,套)</div>
                    <div class="num" :data-content="numberSeparatorCompute(rightCenterData.totalEquipment || 0)">{{ (rightCenterData.totalEquipment || 0) | numberSeparator}}</div>
                  </div>
                </div>
              </div>
              <div class="yj-content">
                <div class="item-class">
                  <div class="title">谷物联合收割机</div>
                  <div class="num">{{rightCenterData.grainHarvester || '0'}}</div>
                </div>
                <div class="item-class">
                  <div class="title">履带式收割机</div>
                  <div class="num">{{rightCenterData.trackedHarvester || '0'}}</div>
                </div>
                <div class="item-class">
                  <div class="title">玉米收获机</div>
                  <div class="num">{{rightCenterData.cornHarvester || '0'}}</div>
                </div>
                <div class="item-class">
                  <div class="title">拖拉机</div>
                  <div class="num">{{rightCenterData.tractor || '0'}}</div>
                </div>
                <div class="item-class">
                  <div class="title">烘干设备</div>
                  <div class="num">{{rightCenterData.drying || '0'}}</div>
                </div>
                <div class="item-class">
                  <div class="title">移动式烘干设备</div>
                  <div class="num">{{rightCenterData.mobileDrying || '0'}}</div>
                </div>
                <div class="item-class">
                  <div class="title">排灌设备</div>
                  <div class="num">{{rightCenterData.irrigate || '0'}}</div>
                </div>
                <div class="item-class">
                  <div class="title">水泵</div>
                  <div class="num">{{rightCenterData.waterPump || '0'}}</div>
                </div>
                <div class="item-class">
                  <div class="title">播种设备</div>
                  <div class="num">{{rightCenterData.sow || '0'}}</div>
                </div>
                <div class="item-class">
                  <div class="title">其他应急装备</div>
                  <div class="num">{{rightCenterData.emergency || '0'}}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div  class="right-part-bottom-left-top"  style="height: 13vh">
            <div class="currency-title">
              <div class="title">
                <span>烘干中心/应急服务队数量统计</span>
              </div>
            </div>
            <div class="bottom-left-top-content">
              <div class="bottom-left-top-content-left">
                <div class="title-num-box">
                  <div class="title">烘干中心</div>
                  <div class="num" :data-content="numberSeparatorCompute(rightCenterData.dryingCount || 0)">{{ (rightCenterData.dryingCount || 0) | numberSeparator}}</div>
                </div>
              </div>
              <div  class="bottom-left-top-content-right">
                <div class="title-num-box">
                  <div class="title">应急服务队</div>
                  <div class="num" :data-content="numberSeparatorCompute(rightCenterData.emergencyCount || 0)">{{ (rightCenterData.emergencyCount || 0) | numberSeparator}}</div>
                </div>
              </div>
            </div>
          </div> -->

          <div  class="right-part-bottom-left-bottom"  style="height: 36vh;display: flex;flex-direction:column;">
            <div class="currency-title">
              <div class="title">
                <span>合作社作业量统计</span>
              </div>
            </div>
            <div class="l_bottom">
              <div class="l_bottom_header">
                <div class="item item1">
                    <div class="item-title-box-num" :data-content="numberSeparatorCompute(leftBottomData.currentYearJobAmount ? Math.round(leftBottomData.currentYearJobAmount) : 0)">{{(leftBottomData.currentYearJobAmount ? Math.round(leftBottomData.currentYearJobAmount) : 0)| numberSeparator}}</div>
                    <!-- <div class="item-title-box-box">
                      <div class="item-title-box-num_1">{{(leftBottomData.currentYearJobAmount ? Math.round(leftBottomData.currentYearJobAmount) : 0)| numberSeparator}}</div>
                      <div class="item-title-box-num_2">{{(leftBottomData.currentYearJobAmount ? Math.round(leftBottomData.currentYearJobAmount) : 0)| numberSeparator}}</div>
                    </div> -->
                    <div>年度作业量({{commonParams.unit}})</div>
                </div>
                <div class="item item2">
                    <div class="item-title-box-num3" :data-content="numberSeparatorCompute((leftBottomData.ratio || 0)) +'%'">{{(leftBottomData.ratio || 0) | numberSeparator}}%</div>
                    <div>作业量占比</div>
                </div>
                <div class="item item3">
                    <div class="item-title-box-num2" :data-content="numberSeparatorCompute(leftBottomData.lastYearJobAmount ? Math.round(leftBottomData.lastYearJobAmount) : 0)">{{(leftBottomData.lastYearJobAmount ? Math.round(leftBottomData.lastYearJobAmount) : 0) | numberSeparator}}</div>
                    <div>去年作业量({{commonParams.unit}})</div>
                </div>
              </div>
              <div
                class="l_b_item"
                v-for="(v, i) in leftBottomData.firstList"
                :key="i"
              >
                <img class="l_b_item_left" :src="require(`../../assets/img/cooperative/new_${i+1}.png`)"/>
                <div class="l_b_item_right">
                  <div class="title" :class="v.cooperationName && v.cooperationName.length >= 20?'title-animation':''">{{ v.cooperationName || "--" }}</div>
                  <div class="num">
                    <span class="title-num" :data-content="numberSeparatorCompute(Math.round(v.jobAmount ? v.jobAmount : 0))">{{ (Math.round(v.jobAmount ? v.jobAmount : 0)) | numberSeparator }}</span>
                    <span class="unit" :data-content="commonParams.unit">{{commonParams.unit}}</span>
                  </div>
                </div>
              </div>
              <vue-seamless-scroll
                :data="leftBottomData.secondList"
                class="seamless-warp"
                :class-option="{...classOption,limitMoveNum:3}"
                v-if="leftBottomData.secondList && leftBottomData.secondList.length >= 1"
              >
                  <div
                    class="l_b_item"
                    v-for="(v, i) in leftBottomData.secondList"
                    :key="i"
                  >
                  <div class="l_b_item_div">
                    {{i + 4}}
                  </div>
                  <div class="l_b_item_right">
                    <div class="title" :class="v.cooperationName && v.cooperationName.length >= 20?'title-animation':''">{{ v.cooperationName || "--" }}</div>
                    <div class="num">
                      <span class="title-num" :data-content="numberSeparatorCompute(Math.round(v.jobAmount ? v.jobAmount : 0))">{{ (Math.round(v.jobAmount ? v.jobAmount : 0)) | numberSeparator }}</span>
                      <span class="unit" :data-content="commonParams.unit">{{commonParams.unit}}</span>
                    </div>
                  </div>
                  </div>
              </vue-seamless-scroll>
              <div v-else style="flex: 1;"></div>
              <el-select
                v-model.trim="commonParams.jobTypeCode"
                placeholder=""
                class="work_select left_work_select"
                v-if="jobTypeList && jobTypeList.length>1"
              >
                <el-option
                    v-for="item in jobTypeList"
                    :key="item.name"
                    :label="item.value"
                    :value="item.name"
                  ></el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="right-part-bottom-right">
          <div class="right-part-bottom-right-chart" style="height: 23vh">
            <div class="currency-title">
              <div class="title">
                <span>各类型合作社分布数量统计</span>
              </div>
            </div>
            <rightTopChart v-if="rightTopChart.regionCooperativeList && rightTopChart.regionCooperativeList.length>0" :chartData="rightTopChart"></rightTopChart>
            <div v-else class="empty_panel"></div>
          </div>
          <div  class="right-part-bottom-right-top"  style="height: 27vh">
            <div class="currency-title">
              <div class="title">
                <span>合作社实时地块信息</span>
              </div>
            </div>
            <vue-seamless-scroll
              :data="rightBottomData"
              class="seamless-warp"
              :class-option="{...classOption,limitMoveNum:3}"
              v-if="rightBottomData && rightBottomData.length>0"
            >
              <div class="r_b_item" v-for="(v,i) in rightBottomData" :key="i">
                <div class="r_b_item_left">
                  <img class="dot" src="../../assets/img/cooperative/dk_dot.png"></img>
                  <img class="line" src="../../assets/img/cooperative/dk_line.png"></img>
                </div>
                <div class="r_b_item_right">
                  <div class="r_b_item_right_left">
                    <div class="r_b_item_right_left_title" :class="v.cooperationName && v.cooperationName.length >= 18?'title-animation':''">
                      {{v.cooperationName}}
                    </div>
                    <div class="r_b_item_right_left_item">地块名称<span class="r_b_item_right_left_value">{{v.plotName}}</span></div>
                    <div class="r_b_item_right_left_item">种植作物<span class="r_b_item_right_left_value">{{v.crops || '--'}}</span></div>
                  </div>
                  <div  class="r_b_item_right_right">
                    <div>面积(亩)</div>
                    <div class="r_b_item_right_right_font">{{v.plotArea}}</div>
                  </div>
                </div>
              </div>
            </vue-seamless-scroll>
          <div v-else class="empty_panel"></div>
          </div>
          <div style="height: 2vh"></div>
          <div  class="right-part-bottom-right-bottom"  style="height: 25vh;">
            <div class="currency-title">
              <div class="title">
                <span>{{ statisticsYear }}年合作社数量同环比</span>
              </div>
            </div>
            <div class="chart_info">
              <rightBottomChart width="56%"
                :chartData="rightTopDataFormat"
                :unit="commonParams.rightTopUnit"></rightBottomChart>
                <div class="info_panel">
                  <div class="switch_panel">
                    <div class="btn" @click="rightTopSwitch = 1" :class="rightTopSwitch == 1?'active':''">同比</div>
                    <div class="btn" @click="rightTopSwitch = 2" :class="rightTopSwitch == 2?'active':''">环比</div>
                  </div>
                  <div class="i_item">
                    <div class="i_top">{{rightTopDataFormat.barName1}}合作社数量</div>
                    <div class="i_bottom">{{(rightTopSwitch == 1?(rightTopData.lastYearMonthCount?rightTopData.lastYearMonthCount : 0):(rightTopData.currentYearLastMonthCount?rightTopData.currentYearLastMonthCount : 0)) | numberSeparator}}</div>
                  </div>
                  <div class="i_item">
                    <div class="i_top">{{rightTopDataFormat.barName2}}合作社数量</div>
                    <div class="i_bottom">{{(rightTopData.currentYearMonthCount?rightTopData.currentYearMonthCount : 0) | numberSeparator}}</div>
                  </div>
                  <div class="i_item">
                    <div class="i_center">{{rightTopSwitch == 1?'同比':'环比'}} <span :class="Number(rightTopSwitch == 1?rightTopData.lastYearRatio:rightTopData.lastMonthRatio)<0?'other':''">{{Number(rightTopSwitch == 1?rightTopData.lastYearRatio:rightTopData.lastMonthRatio)<0?'减少':'增长'}}</span></div>
                    <div class="i_bottom">
                      <span class="icon" :class="Number(rightTopSwitch == 1?rightTopData.lastYearRatio:rightTopData.lastMonthRatio)<0?'rotate':''"></span>
                      {{(rightTopSwitch == 1?(rightTopData.lastYearMonthCount != null?rightTopData.lastYearMonthCount : 0):(rightTopData.currentYearLastMonthCount != null ?rightTopData.currentYearLastMonthCount : 0)) == null ?'--':Math.abs(rightTopSwitch == 1?rightTopData.lastYearRatio:rightTopData.lastMonthRatio)+'%' || 0+'%'}}
                    </div>
                  </div>
                  <el-select
                    v-model.trim="commonParams.rightTopMonth"
                    placeholder=""
                    class="work_select month_select"
                  >
                    <el-option
                      v-for="item in monthOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page_fold_panel">
      <div class="right_fold">
        <div v-if="getRightFold" @click="$store.dispatch('setRightFold', false)">
          <img class="open" v-if="getRightFold" src="../../assets/images/common/icon_arrows_r.png" alt="">
        </div>
        <div v-else @click="$store.dispatch('setRightFold', true)">
          <img class="close" src="../../assets/images/common/icon_arrows_l.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import cityMap from "./components/homeMap";
import mapModel from "./components/mapModel";
import homePolyline from "@components/chart/polyline";
import * as cooperativeApi from "@/api/cooperative";
import * as homeApi from "@/api/home";
import { mapGetters } from "vuex";
import Modal from "@components/modal.vue";
import iconMap from "@/utils/iconType";
import cooperativeIconMap from "@/utils/newCooperativeIconType";
import { parseTime, debounce } from "@/utils/index";
import rightTopChart from "./components/right_top_chart.vue";
import rightBottomChart from "./components/right_bottom_chart.vue";


const defaultRightChecked = {
  active: true,
  bgUrl: require('@/assets/img/vehicle_icons/two/menu_bg_c.png'),
  cooperativeTypeCode: "defaultRight",
  cooperativeTypeName: "全部",
  iconUrl: require('@/assets/images/cooperativeIcon/btn_menu_yj_c.png'),
  iconUrl_: require('@/assets/images/cooperativeIcon/btn_menu_yj.png'),
}

const defaultLeftChecked = {
  active: true,
  bgUrl: require('@/assets/img/vehicle_icons/two/menu_bg_c.png'),
  cooperativeTypeCode: "defaultLeft",
  cooperativeTypeName: "全部",
  iconUrl: require('@/assets/images/cooperativeIcon/btn_menu_all_c.png'),
  iconUrl_: require('@/assets/images/cooperativeIcon/btn_menu_all.png'),
}

export default {
  components: {
    mapModel,
    cityMap,
    homePolyline,
    Modal,
    rightTopChart,
    rightBottomChart
  },
  data() {
    return {
      // 合作社类型（左侧选中项）
      leftChecked: [defaultLeftChecked],
      // 合作社类型（右侧选中项）
      rightChecked: [],
      // 合作社作业量统计 (左下)
      leftBottomData: {
        // 当年作业量
        currentYearJobAmount: '',
        // 去年作业量
        lastYearJobAmount: '',
        // 作业量比例
        ratio: '',
        // 合作社作业量列表
        jobAmountList: [],

      },
      // 合作社分布数量统计
      rightTopChart: {
        regionCooperativeList: [],
        legends: [],
      },
      // 烘干中心/应急服务队数量统计 (右中)
      rightCenterData: {
        dryingCount: 0,
        emergencyCount: 0
      },
      //  合作社实时地块信息 (右下)
      rightBottomData: [],
      // 作业类型数据
      jobTypeList: [],
      // 统计年份
      statisticsYear: new Date().getFullYear(),
      rightTopSwitch: 1,
      // 右上图标数据（请求数据
      rightTopData: {
        "currentYearMonthCount": 0, // 当前月份作业量
        "lastYearMonthCount": 0, // 上年同期作业量
        "currentYearLastMonthCount": 0, // 上月同期作业量
        "lastYearRatio": 0.0, // 同比比例（与去年同期作业量比例）
        "lastMonthRatio": 0.0 // 环比比例（与上月作业量比例）
      },
      backgroundArr: ['#DC9300', '#DADE00', '#00C0DE'],
      vehicleTypes: [],
      // 所需合作社类型12项
      needCooperativeType: ['defaultLeft', '1', '2', '3', '4', '5', 'defaultRight', '6', '7', '8', '9', '10'],
      // 合作社左侧6项筛选
      leftTypeList: [],
      // 合作社右侧6项筛选
      rightTypeList: [],
      // 获取合作社 头部 统计数据
      headerStatics: {
        // 合作社总量			 
        cooperationCount: 0,
        // 入社农机数量
        joinVehicleCount: 0,
        // 入社人数
        joinUserCount: 0,
        // 省级服务中心（家）
        provinceServerCount: 0,
        // 市级服务中心（家）
        cityServerCount: 0,
        // 县区级服务中心（家）
        countyServerCount: 0,
      },
      // 通用参数
      commonParams: {
        jobTypeCode: '',
        //作业类型单位
        unit: '亩',
        rightTopMonth: new Date().getMonth()+1,
        filterType: 0,
        // 服务中心级别：1省级、2市级、3县级
        serverLevelStr: '1,2,3',
        // 认证状态：1 一般认证 0一般未认证
        authStr: '1,0',
        // 烘干中心 勾选传1
        drying: '',
        // 应急服务队 勾选传1
        emergencyServer: '',
        // 收割机大户 勾选传1
        harvester: '',
        // 种地大户 勾选传1
        largeScaleFarmer: '',
        // 拖拉机大户 勾选传1
        tractor: '',
        // 合作社来源
        source: '2'
      },
      // 合作社点
      pointList: [],
      // 终端类型
      terminalType: 0,
      parseTime,
      showVehicleType: true,
      iconMap,
      cooperativeIconMap,
      landName: "",
      typeStep: 0,
      dialogLeft: "200px",
      isMove: false,
      dialogSign: false,
      contentType: 0,
      dialog: false,
      mapLine: {},
      areaList: [],
      mapData: {},
      selectAllTypeFlag: false,
      geoPath: "/js/henan.json",
      // 作业类型选择,默认小麦收获作业
      currentVehicleTypeCodes: "5-188",
      detailInfo: {},
      echatsInitFlag: true,
      selectNumData: {},
      // 月份下拉
      monthOptions: [
        { value: 1, label: "1月" },
        { value: 2, label: "2月" },
        { value: 3, label: "3月" },
        { value: 4, label: "4月" },
        { value: 5, label: "5月" },
        { value: 6, label: "6月" },
        { value: 7, label: "7月" },
        { value: 8, label: "8月" },
        { value: 9, label: "9月" },
        { value: 10, label: "10月" },
        { value: 11, label: "11月" },
        { value: 12, label: "12月" },
      ],
      // 统计年份
      yearStatistics: 2022,
      // 统计年份列表
      yearsList: [{ value: 2022, label: "2022年" }],
      // 点击折叠次数
      clickIndex: 2,
      // 展示行
      showRow: true,
      userList: [], // 机手
      vehicleList: [], // 车辆
      userPointList: [], // 可联系机手
      vehiclePointList: [], // 可联系车辆
      cooperativeSource: '2', // 合作社来源类型 0政府 1用户 2全部
      cooperativeSourceOptions: [], //合作社来源列表
    };
  },
  watch: {
    /** 右上月份变更 */
    "commonParams.rightTopMonth": {
      deep: true,
      handler(newVal,oldVal) {
        if(oldVal != newVal) this.getCountRatio();
      }
    },
    "$store.state.activeRegionObj": {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val.areaCode) return;
        this.currentVehicleTypeCodes = "5-188";
        this.selectAllTypeFlag = false;
        this.initPageData();
        // const city = val.areaCode.slice(0, -3);
        this.$nextTick(() => {
          if (this.$refs.mapModel) {
            // if (this.echatsInitFlag) {
            //   this.echatsInitFlag = false;
            // } else {
            //   this.$refs.mapModel.clearEchartsLyerData();
            // }
            this.$refs.mapModel.addProvince(val.areaCode);

            // this.point();
          }
        });
      },
    },
    // 作业类型
    "commonParams.jobTypeCode": {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.getJobAmountList();
          this.commonParams.unit =
            this.jobTypeList.find((v) => {
              return v.name == val;
            }).unit || "亩";
        }
      },
    },
    // 合作社数据来源
    cooperativeSource: {
      handler(val) {
        this.commonParams.source = val;
        this.initPageData();
      }
    },
  },
  name: "cooperativeInfo",
  methods: {
    // 大屏作业进度终端类型下拉列表
    getCooperativeSourceOptions() {
      homeApi.getDictData('cooperative_source_options').then((res) => {
        this.cooperativeSourceOptions =  res || []; 
      });
    },
    // 各类型合作社分布数量统计
    getTypeCountByArea() {
      let params = {
        ...this.commonParams,
      };
      // if (this.selectAllTypeFlag) params.vehicleTypeCode = "";
      cooperativeApi.getTypeCountByArea(params).then((res) => {
        //  this.$set(this, headerStatics, res);
        let labelNames = [];
        let names = ['省级', '市级', '县级', '一般认证', '一般未认证'];
        let regionCooperativeList = [
          {
            type: '1',
            name: '省级',
            count: [],
          },
          {
            type: '2',
            name: '市级',
            count: [],
          },
          {
            type: '3',
            name: '县级',
            count: [],
          },
          {
            type: '4',
            name: '一般认证',
            count: [],
          },
          {
            type: '5',
            name: '一般未认证',
            count: [],
          },
          {
            type: '6',
            name: '总数',
            count: [],
          },
        ]
        if(res) {
          res.forEach(item => {
            if(item.typeCountList) {
              let total = 0;
              item.typeCountList.forEach(it => {
                total += it.count
              })
              item.typeCountList.push({type: '6', count: total});
            }
          })
          res.forEach(item => {
            if(!item.typeCountList) item.typeCountList = [];
            if(item.areaName) {
              labelNames.push((item.areaName.length > 4 ? item.areaName.slice(0, 3) + '...' : item.areaName) + ',' + item.typeCountList[item.typeCountList.length - 1].count);
              // labelNames.push([item.areaName, '\n', item.typeCountList[item.typeCountList.length - 1].count]);
            }
            
            if(item.typeCountList) {
              for(let i = 0; i < item.typeCountList.length; i++) {
                regionCooperativeList[i].count.push(item.typeCountList[i].count);
              }
            }
          })

          let CooperativeListCopy = regionCooperativeList;
          let labelNamesCopy = labelNames;
          let that = this;
          if(CooperativeListCopy && CooperativeListCopy.length >= 10) {
            setInterval(function () {  
              CooperativeListCopy.push(CooperativeListCopy.shit());
              labelNamesCopy.push(labelNamesCopy.shit());
              that.$set(that.rightTopChart, 'regionCooperativeList', CooperativeListCopy);
              that.$set(that.rightTopChart, 'labelNames', labelNamesCopy);
              // that.rightTopChart.regionCooperativeList = CooperativeListCopy;
              // that.rightTopChart.labelNames = labelNamesCopy;
            }, 1000); // 每2秒滚动一次
          }else {
            this.rightTopChart.regionCooperativeList = regionCooperativeList;
            this.rightTopChart.labelNames = labelNames;
          }
          this.rightTopChart.legends = names;
        }
      });
    },
    // 获取地块
    getPlotListByCooperation() {
      let params = {
        ...this.commonParams,
      };
      cooperativeApi.getPlotListByCooperation(params).then((res) => {
        if(res) {
          let lands = res.map(item => {
          return {
              ...item,
              geometry: item.geometry ? JSON.parse(item.geometry) : []
            }
          })
          this.$refs.mapModel.addLandsLayer(lands);
        }
      })
    },
    // 获取聚合信息
    getAreaCount() {
      let params = {
        ...this.commonParams,
      };
      cooperativeApi.getAreaCount(params).then(res=>{
        const arr = JSON.parse(JSON.stringify(res || []));
        this.$refs.mapModel.resetAreaCount(arr);
      })
    },
    // 获取合作社点
    point() {
      this.getAreaCount();
    },
    // 获取合作社数量同比、环比
    getCountRatio() {
      let params = {
        ...this.commonParams,
        month: this.commonParams.rightTopMonth,
      };
      cooperativeApi.getCountRatio(params).then((res) => {
        if(res) { 
          this.rightTopData = Object.assign(this.rightTopData, res);
        }else {
          this.rightTopData = {
            "currentYearMonthCount": 0, // 当前月份作业量
            "lastYearMonthCount": 0, // 上年同期作业量
            "currentYearLastMonthCount": 0, // 上月同期作业量
            "lastYearRatio": 0.0, // 同比比例（与去年同期作业量比例）
            "lastMonthRatio": 0.0 // 环比比例（与上月作业量比例）
          }
        }
      })
    },
    // 获取实时地块
    getCooperationPlotList() {
      let params = {
        ...this.commonParams,
      };
      cooperativeApi.getCooperationPlotList(params).then((res) => {
        this.rightBottomData = res || [];
        // this.rightBottomData[0].cooperationName = '我很长我很长我很长我很长我很长我很长我很长结束了！！！'
      })
    },
    // 烘干中心/应急服务队数量统计
    getDryingEmergencyCount() {
      let params = {
        ...this.commonParams,
      };
      cooperativeApi.getDryingEmergencyCount(params).then((res) => {
        this.rightCenterData = Object.assign(this.rightCenterData, res);
      })
      
    },
    // 合作社作业量统计
    getJobAmountList() {
      let params = {
        ...this.commonParams,
      };
      if(this.commonParams.jobTypeCode == '8888') {
        params.jobTypeCode = null;
      }
      cooperativeApi.getJobAmountList(params).then((res) => {
        this.leftBottomData = Object.assign(this.leftBottomData, res);
        if(this.leftBottomData.jobAmountList) {
          let allList = this.leftBottomData.jobAmountList;
          if(allList.length > 3) {
            this.leftBottomData.firstList = allList.slice(0,3);
            // this.leftBottomData.firstList[0].cooperationName = '我是我是我是我是我是我是我是我是我是我是我是';
            this.leftBottomData.secondList = allList.slice(3);
          }else {
            this.leftBottomData.firstList = allList;
            this.leftBottomData.secondList = [];
          }
        }
      })
    },
    // 收齐
    packUp() {
      if (this.clickIndex == 1) {
        this.showVehicleType = !this.showVehicleType;
      }
      if (this.clickIndex == 2) {
        this.showRow = false;
      }
      if (this.clickIndex == 3) {
        this.clickIndex = 1;
        this.showRow = true;
        this.showVehicleType = !this.showVehicleType;
        return;
      }
      this.clickIndex = this.clickIndex + 1;
    },
    // 获取年份列表
    getYearsList() {
      let date = new Date();
      let year = date.getFullYear();
      let number = year - 2022;
      let arr = [{ value: 2022, label: "2022年" }];
      for (let i = 1; i <= number; i++) {
        arr.push({
          value: 2022 + i,
          label: 2022 + i + "年",
        });
      }
      this.yearsList = arr;
    },
    selectNum(data, item) {
      this.selectNumData = data;
      let that = this;
      function request() {
        that.point();
      }
      debounce(request, 1200)
    },
    featureClick(cityItem) {
      // let areaCode = cityItem.adcode;
      // if (
      //   this.getactiveRegionObj &&
      //   this.getactiveRegionObj.areaCode == "419001000"
      // )
      //   return; // 济源市比较特殊，防止多次下钻
      // let selectCityItem = null;
      // const regionList = JSON.parse(localStorage.getItem("regionList"));
      // regionList.map((item) => {
      //   if (item.areaCode === String(areaCode) + "000") {
      //     selectCityItem = item;
      //   }
      // });
      // this.$store.dispatch("setactiveRegionObj", selectCityItem);
    },
    selectType(item, allArr, flag) {
      allArr.forEach(el => {
        if(el.cooperativeTypeCode == item.cooperativeTypeCode) {
          el.active = !el.active;
        }
      });
      if(flag == 'left') {
        if(item.cooperativeTypeCode == 'defaultLeft') {
          if(item.active) {
            allArr.forEach(el => {
              el.active = false;
            })
            allArr[0].active = true;
            this.leftChecked = [];
            this.leftChecked.push(allArr[0]);
          }else {
            this.leftChecked = allArr.filter(item => {
              return item.active == true;
            })
            if(this.leftChecked.length == 0) {
              allArr[0].active = true;
              this.leftChecked.push(allArr[0]);
            }
          }
        }else {
          this.leftChecked = allArr.filter(item => {
            return item.active == true;
          })
          if(this.leftChecked.length == 0) {
            allArr[0].active = true;
          }
          if(this.leftChecked.length > 1) {
            allArr[0].active = false;
          }
          if(this.leftChecked.length == 0) {
            this.leftChecked.push(allArr[0]);
          }
        }
      }else {
        if(item.cooperativeTypeCode == 'defaultRight') {
          if(item.active) {
            allArr.forEach(el => {
              el.active = false;
            })
            allArr[0].active = true;
            this.rightChecked = [];
            this.rightChecked.push(allArr[0]);
          }else {
            this.rightChecked = [];
          }
        }else {
          this.rightChecked = allArr.filter(item => {
            return item.active == true;
          })
          if(this.rightChecked.length > 1) {
            allArr[0].active = false;
          }
        }

      }

      let allChecked = [];
      allChecked = (this.leftChecked.concat(this.rightChecked)).filter(item => {
        return item.active;
      })
      allChecked = allChecked.map(item => {
        return item.cooperativeTypeCode
      })

      this.commonParams.serverLevelStr = [];
      this.commonParams.authStr = [];
      this.commonParams.emergencyServer = '';
      this.commonParams.drying = '';
      this.commonParams.harvester = '';
      this.commonParams.tractor = '';
      this.commonParams.largeScaleFarmer = '';

      allChecked.forEach(item => {
        if(item == 1 || item == 2 || item == 3) {
          this.commonParams.serverLevelStr.push(item);
        }
        if(item == 4 || item == 5) {
          if(item == 4) {
            this.commonParams.authStr.push(1);
          }
          if(item == 5) {
            this.commonParams.authStr.push(0);
          }
        }
        if(item == 6) {
          this.commonParams.emergencyServer = 1;
        }
        if(item == 7) {
          this.commonParams.drying = 1;
        }
        if(item == 8) {
          this.commonParams.harvester = 1;
        }
        if(item == 9) {
          this.commonParams.tractor = 1;
        }
        if(item == 10) {
          this.commonParams.largeScaleFarmer = 1;
        }
        if(item == 'defaultLeft') {
          this.commonParams.serverLevelStr = [1,2,3];
          this.commonParams.authStr =  [0,1];
        }
        if(item == 'defaultRight') {
          this.commonParams.emergencyServer = 1;
          this.commonParams.drying = 1;
          this.commonParams.harvester = 1;
          this.commonParams.tractor = 1;
          this.commonParams.largeScaleFarmer = 1;
        }
      })
      this.commonParams.serverLevelStr =  this.commonParams.serverLevelStr.join(',');
      this.commonParams.authStr =  this.commonParams.authStr.join(',');

      // let codeArr = [];

      // this.currentVehicleTypeCodes = codeArr.join("-");
      // let that = this;
      // function request() {
      //   that.point();
      //   that.getCooperativeStatics();
      //   that.getVehicleJobNumber();
      // }
      // debounce(request, 1200)

      debounce(this.initPageData, 1200)
    },
    initPageData() {
      this.getJobTypeList();
      this.getCooperativeStatics();
      this.getTypeCountByArea();
      this.getJobAmountList();
      this.getDryingEmergencyCount();
      this.getCooperationPlotList();
      this.getCountRatio();
      this.getPlotListByCooperation();
      this.point();

    },
    /** 获取作业类型 */
    getJobTypeList() {
      cooperativeApi.getJobType({ ...this.commonParams }).then((res) => {
        this.commonParams.jobTypeCode = null;
        if(res) {
          res.unshift({name: '8888', value: '全部'});
          if (res && res.length > 0) {
            this.commonParams.jobTypeCode = res[0].name;
            this.commonParams.unit = res[0].unit;
          }
          this.jobTypeList = res;
        }
      });
    },
    // 获取合作社信息统计
    getCooperativeStatics() {
      let params = {
        ...this.commonParams,
      };
      cooperativeApi.getCooperativeStatics(params).then((res) => {
        this.headerStatics = Object.assign(this.headerStatics, res);
      });
    },

  },
  computed: {
    numberSeparatorCompute() {
      return function(number){
        let regex = /(?!^)(?=(\d{3})+(\.|$))/g;
          if (!number) {
            return 0;
          }else {
            return number.toString().replace(regex, ',');
          }
      }
    },
    ...mapGetters(["getactiveRegionObj", "getRightFold"]),
    /** 右上数据格式化处理 */
    rightTopDataFormat() {
      /** 当前选择年月 */
      let nowSelectTime = new Date(`${this.statisticsYear}.${this.commonParams.rightTopMonth}`);
      /** 上一年 */
      let year_Mill = new Date(nowSelectTime).setFullYear((new Date(nowSelectTime).getFullYear() - 1));
      /** 上一月 */
      let month_Mill = new Date(nowSelectTime).setMonth((new Date(`${nowSelectTime}`).getMonth() - 1));
      if(this.rightTopSwitch == 1) {
        return {
          regionList: [parseTime(year_Mill,'{y}.{m}'),parseTime(nowSelectTime,'{y}.{m}')],
          // valueList1: [(this.rightTopData && ('lastYearMonthCount' in this.rightTopData) ? this.rightTopData.lastYearMonthCount : 0), null],
          // valueList2: [null,(this.rightTopData && ('currentYearMonthCount' in this.rightTopData) ? this.rightTopData.currentYearMonthCount : 0)],
          barName1: parseTime(year_Mill,'{y}年{m}月'),
          barName2: parseTime(nowSelectTime,'{y}年{m}月'),
          valueList: [(this.rightTopData && ('lastYearMonthCount' in this.rightTopData) ? this.rightTopData.lastYearMonthCount : 0), (this.rightTopData && ('currentYearMonthCount' in this.rightTopData) ? this.rightTopData.currentYearMonthCount : 0)],
          colorArr: [['rgba(255, 191, 0, ', 'rgba(209, 162, 6, '],['rgba(54, 245, 168, ','rgba(49, 206, 141, ']],
        };
      } else {
        return {
          regionList: [parseTime(month_Mill,'{y}.{m}'),parseTime(nowSelectTime,'{y}.{m}')],
          // valueList1: [(this.rightTopData.currentYearLastMonthCount || 0), null],
          // valueList2: [null,(this.rightTopData && ('currentYearMonthCount' in this.rightTopData) ? this.rightTopData.currentYearMonthCount : 0)],
          barName1: parseTime(month_Mill,'{y}年{m}月'),
          barName2: parseTime(nowSelectTime,'{y}年{m}月'),
          valueList: [(this.rightTopData.currentYearLastMonthCount || 0), (this.rightTopData && ('currentYearMonthCount' in this.rightTopData) ? this.rightTopData.currentYearMonthCount : 0)],
          colorArr: [['rgba(255, 191, 0, ', 'rgba(209, 162, 6, '],['rgba(54, 245, 168, ','rgba(49, 206, 141, ']],
        };
      }
      return 
    },
    classOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 7, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    classOption1() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  mounted() {
    //this.initPageData()'
    let list = this.needCooperativeType.map(v => {
      return {
        cooperativeTypeCode: this.cooperativeIconMap[String(v)].code,
        cooperativeTypeName: this.cooperativeIconMap[String(v)].name,
        iconUrl_: this.cooperativeIconMap[String(v)].item_icon_,
        iconUrl: this.cooperativeIconMap[String(v)].item_icon,
        bgUrl: this.cooperativeIconMap[String(v)].bg_icon,
        active: v == 'defaultLeft',
        className: this.cooperativeIconMap[String(v)].className,
      }
    })

    this.leftTypeList = list.slice(0,6);
    this.rightTypeList = list.slice(6);
    this.getYearsList();
  },
  created() {
    this.getCooperativeSourceOptions();
  },
};
</script>
<style scoped lang="scss">
@font-face {  
  font-family: 'Furore'; /* 自定义字体名称 */  
  src: url('../../assets/fonts/Furore-2.otf') format('opentype'); /* 路径和格式 */  
}  
@font-face {  
  font-family: 'DINPro'; /* 自定义字体名称 */  
  src: url('../../assets/fonts/DINPro.ttf') format('truetype'); /* 路径和格式 */  
}  
@import "@assets/css/var.scss";
@font-face {  
  font-family: 'Rajdhani'; /* 自定义字体名称 */  
  src: url('../../assets/fonts/Rajdhani-SemiBold.ttf') format('truetype'); /* 路径和格式 */  
}  


.main_container{
  margin-top: vh(-10);
}
::v-deep.el-select-dropdown__item,.option_class{
  text-align:center !important;

}

.left-part {
  flex: 1;
  position: relative;
  .left-part-top-move {
    transform: translate(33%, 0);
  }
  .left-part-bottom-move {
    transform: translate(38%, 0);
  }
  .left-part-top {
    width: vw(1120);
    display: flex;
    position: absolute;
    flex-wrap: nowrap;
    left: vw(34);
    z-index: 99;
    .left-part-top_item {
      width: vw(199);
      height: vh(81);
      // cursor: pointer;
      background-image: url("../../assets/img/home/data_num_bg_hzs.png");
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding: vh(10) 0 vw(4) 0;
      margin-left: vw(-10);
      &.notdrap {
        cursor: no-drop;
      }
      .title {
        font-size: fontSize(16);
        color: #ffffff;
        font-weight: bold;
        background: linear-gradient(180deg, #DEFFF4 60.6201171875%, #7AFFD3 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-left: vw(30);
        margin-top: vh(8);
      }
      .num {
        position: relative;
        font-family: Furore;
        // color: #ffffff;
        letter-spacing: 2px;
        // font-weight: bold;
        font-size: fontSize(26);
        background: linear-gradient(180deg, #FFFFFF 70%, #BDFFCC 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-left: vw(30);
        // text-shadow: 0 0 4px rgb(0,255,208,0.46);
      }
      .num::before {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        color: transparent;
        text-shadow:
          // 0 0 1px rgba(255,255,255,0.3), /* 第一层阴影：内阴影 */
          // 0 0 1px rgba(255,255,255,0.3), /* 第二层阴影：稍微外移一点的阴影 */
          // 0 0 6px rgba(0,255,208,1), /* 第三层阴影 */
          0 0 8px rgba(0,255,208,1); /* 第四层阴影 */
      }
    }
  }

  .left_item_list {
    // display: flex;
    position: absolute;
    flex-wrap: nowrap;
    left: 0;
    top: vh(68);
    z-index: 99;
    cursor: pointer;
  }

  .bottom_item_list {
    position: absolute;
    flex-wrap: nowrap;
    left: vw(16);
    bottom: vh(194);
    z-index: 99;
    cursor: pointer;
  }
}

.left_icon_default {
  width: vw(198);
  height: vh(71);
  margin-top: vh(40);
  margin-left: vw(4);
}

.left_icon_1 {
  width: vw(199);
  height: vh(70);
  margin-left: vw(24);
  margin-top: vh(14);
}

.left_icon_2 {
  width: vw(199);
  height: vh(60);
  margin-left: vw(32);
  margin-top: vh(26);
}

.left_icon_3 {
  width: vw(199);
  height: vh(59);
  margin-left: vw(32);
  margin-top: vh(34);
}

.left_icon_4 {
  width: vw(160);
  height: vh(53);
  margin-left: vw(24);
  margin-top: vh(32);
}

.left_icon_5 {
  width: vw(179);
  height: vh(58);
  margin-top: vh(34);
}

.bootom_list_box {
  display: flex;
  position: absolute;
  flex-wrap: nowrap;
  align-items: baseline;
  // overflow-y: scroll;
  z-index: 100;
}

.bottom_icon_default {
  width: vw(157);
  height: vh(63);
}

.bottom_icon_6 {
  width: vw(197);
  height: vh(63);
  margin-left: vw(-10);
}

.bottom_icon_7 {
  width: vw(187);
  height: vh(80);
  margin-left: vw(-10);
}

.bottom_icon_8 {
  width: vw(197);
  height: vh(60);
  margin-left: vw(-10);
}

.bottom_icon_9 {
  width: vw(197);
  height: vh(60);
  margin-left: vw(-10);
} 

.bottom_icon_10 {
  width: vw(187);
  height: vh(60);
  margin-left: vw(-10);
}




.main_list {
  display: flex;
  position: absolute;
  flex-wrap: nowrap;
  top: vh(75);
  left: vw(6);
  flex-direction: column;
  max-height: vh(820);
  overflow-y: auto;
  z-index: 99;
}
.main_list::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.main_list::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background-color: #0dffa9;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
}
.main_list::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #023f30;
  border-radius: 2px;
}

.map_container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  height: vh(1080);
  float: right;
}

.right-part {
  width: vw(736);
  z-index: 2;
  padding: vh(14) 0;
  margin-right: vw(20);
  position: absolute;
  right: 0;
  // .right-part-top {
  //   width: vw(722);
  //   .currency-title-long {
  //     width: vw(722);
  //     height: vh(40);
  //     flex: none;
  //     display: flex;
  //     align-items: center;
  //     color: #ffffff;
  //     justify-content: space-between;
  //     align-items: center;
  //     background: url("../../assets/img/home/tittle_bg_l.png");
  //     background-repeat: no-repeat;
  //     background-size: 100% 100%;
  //     .title {
  //       margin-top: vh(-4);
  //       margin-left: vw(40);
  //       font-weight: bold;
  //       font-size: fontSize(20);
  //       color: #FFFFFF;
  //       text-shadow: 0px 2px 0px rgba(0,18,11,0.34), 2px 6px 0px rgba(115,255,199,0.13);
  //     }
  //   }
  // }
  .right-part-bottom {
    display: flex;
    width: vw(350);
    .right-part-bottom-left {
      margin-right: vw(20);
      .right-part-bottom-left-top {
        .bottom-left-top-content {
          .bottom-left-top-content-item {
            margin-top: vh(8);
            width: vw(344);
            height: vw(75);
            background: url("../../assets/img/cooperative/bg_hg.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            .title-num-box {
              position: absolute;
              top: vh(19);
              left: vw(66);
              display: flex;
              .title-num-box-item {
                color: #FFFFFF;
                .title {
                  font-family: Microsoft YaHei;
                  font-weight: 600;
                  font-size: fontSize(14);
                  line-height: vh(20);
                  background: linear-gradient(180deg, #FFF7DE 60.6201171875%, #FFDE7A 100%);
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                }
                .num {
                  font-family: Furore;
                  background: linear-gradient(180deg, #FFFFFF 34.6923828125%, #FFEEBD 100%);
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  font-size: fontSize(20);
                  position: relative;
                }
                .num::before {
                  content: attr(data-content);
                  position: absolute;
                  top: 0;
                  left: 0;
                  z-index: -1;
                  color: transparent;
                  width: 20px;
                  height: 20px;
                  text-shadow:
                    0 0 1px rgba(255,255,255,0.8), /* 第一层阴影：内阴影 */
                    0 0 1px rgba(255,255,255,0.8), /* 第二层阴影：稍微外移一点的阴影 */
                    0 0 6px rgba(255,212,0,1), /* 第三层阴影 */
                    0 0 6px rgba(255,212,0,1); /* 第四层阴影 */
                }
              }
              .title-num-box-item:first-child {
                margin-right: vw(16);
              }
            }
          }
          .bottom-left-top-content-item:nth-child(2) {
            width: vw(344);
            height: vw(75);
            margin-top: 0;
            background: url("../../assets/img/cooperative/bg_yj.png") no-repeat;
            background-size: 100% 100%;
            .title-num-box {
              .title-num-box-item {
                .title {
                  font-family: Microsoft YaHei;
                  font-weight: 600;
                  font-size: fontSize(14);
                  line-height: vh(20);
                  background: linear-gradient(180deg, #DEFFFE 60.6201171875%, #7AFFFB 100%);
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                }
                .num {
                  font-family: Furore;
                  font-weight: 400;
                  font-size: fontSize(20);
                  color: #FFFFFF;
                  background: linear-gradient(180deg, #FFFFFF 34.6923828125%, #BDFFFD 100%);
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  position: relative;
                }
                .num::before {
                  content: attr(data-content);
                  position: absolute;
                  top: 0;
                  left: 0;
                  z-index: -1;
                  color: transparent;
                  width: 20px;
                  height: 20px;
                  text-shadow:
                    0 0 1px rgba(255,255,255,0.8), /* 第一层阴影：内阴影 */
                    0 0 1px rgba(255,255,255,0.8), /* 第二层阴影：稍微外移一点的阴影 */
                    0 0 6px rgba(0,217,255,1), /* 第三层阴影 */
                    0 0 6px rgba(0,217,255,1); /* 第四层阴影 */
                }
              }
            }
          }
          .yj-content {
            margin-top: vh(-18);
            padding: vh(24) vw(8) 0 vw(8);
            width: vw(344);
            height: vh(220);
            line-height: vh(22);
            background: url("../../assets/img/cooperative/bg_con_yj.png") no-repeat;
            background-size: 100% 100%;
            font-family: Microsoft YaHei;
            font-size: fontSize(14);
            color: #FFFFFF;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            .item-class {
              width: vw(109);
              height: vh(50);
              text-align: center;
              .title {
                height: vh(24);
                background: #006B64;
              }
              .num {
                height: vh(24);
              }
            }
          }
        }
      }

      // .right-part-bottom-left-top {
      //   .bottom-left-top-content {
      //     display: flex;
      //     margin-top: vh(2);
      //     .bottom-left-top-content-left {
      //       width: vw(168);
      //       height: vw(75);
      //       background: url("../../assets/img/cooperative/bg_tj_hg.png") no-repeat;
      //       background-size: 100% 100%;
      //       position: relative;
      //       .title-num-box {
      //         position: absolute;
      //         left: vw(68);
      //         bottom: vh(16);
      //         display: flex;
      //         flex-direction: column;
      //         .title {
      //           font-weight: bold;
      //           background: linear-gradient(180deg, #FFF7DE 60.6201171875%, #FFDE7A 100%);
      //           -webkit-background-clip: text;
      //           -webkit-text-fill-color: transparent;
      //           font-size: fontSize(14);
      //         }
      //         .num {
      //           font-family: Furore;
      //           background: linear-gradient(180deg, #FFFFFF 34.6923828125%, #FFEEBD 100%);
      //           -webkit-background-clip: text;
      //           -webkit-text-fill-color: transparent;
      //           font-size: fontSize(22);
      //           position: relative;
      //         }
      //         .num::before {
      //           content: attr(data-content);
      //           position: absolute;
      //           top: 0;
      //           left: 0;
      //           z-index: -1;
      //           color: transparent;
      //           width: 20px;
      //           height: 20px;
      //           text-shadow:
      //             0 0 1px rgba(255,255,255,0.8), /* 第一层阴影：内阴影 */
      //             0 0 1px rgba(255,255,255,0.8), /* 第二层阴影：稍微外移一点的阴影 */
      //             0 0 6px rgba(255,212,0,1), /* 第三层阴影 */
      //             0 0 6px rgba(255,212,0,1); /* 第四层阴影 */
      //         }
      //       }
      //     }
      //     .bottom-left-top-content-right {
      //       position: relative;
      //       width: vw(168);
      //       height: vw(75);
      //       background: url("../../assets/img/cooperative/bg_tj_yj.png") no-repeat;
      //       background-size: 100% 100%;
      //       .title-num-box {
      //         position: absolute;
      //         left: vw(68);
      //         bottom: vh(16);
      //         display: flex;
      //         flex-direction: column;
      //         .title {
      //           font-weight: bold;
      //           background: linear-gradient(180deg, #DEFFFE 60.6201171875%, #7AFFFB 100%);
      //           -webkit-background-clip: text;
      //           -webkit-text-fill-color: transparent;
      //           font-size: fontSize(14);
      //         }
      //         .num {
      //           font-family: Furore;
      //           background: linear-gradient(180deg, #FFFFFF 34.6923828125%, #BDFFFD 100%);
      //           -webkit-background-clip: text;
      //           -webkit-text-fill-color: transparent;
      //           font-size: fontSize(22);
      //           position: relative;
      //         }
      //         .num::before {
      //           content: attr(data-content);
      //           position: absolute;
      //           top: 0;
      //           left: 0;
      //           z-index: -1;
      //           color: transparent;
      //           width: 20px;
      //           height: 20px;
      //           text-shadow:
      //             0 0 1px rgba(255,255,255,0.8), /* 第一层阴影：内阴影 */
      //             0 0 1px rgba(255,255,255,0.8), /* 第二层阴影：稍微外移一点的阴影 */
      //             0 0 6px rgba(0,217,255,1), /* 第三层阴影 */
      //             0 0 6px rgba(0,217,255,1); /* 第四层阴影 */
      //         }
      //       }
      //     }
      //   }
      // }
    }

    .right-part-bottom-left-bottom {
      .l_bottom {
        .seamless-warp {
          height: vh(104);
          .l_b_item {
            height: vh(50);
          }
        }
      }
    }

    .right-part-bottom-right {
      position: relative;
      top: vh(-35);
      .right-part-bottom-right-chart {
        width: vw(352);
        margin-bottom: vh(26);
        .currency-title-long {
          width: vw(352);
          height: vh(38);
          flex: none;
          display: flex;
          align-items: center;
          color: #ffffff;
          justify-content: space-between;
          align-items: center;
          background: url("../../assets/img/home/tittle_bg_l.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          .title {
            margin-top: vh(-4);
            margin-left: vw(40);
            font-weight: bold;
            font-size: fontSize(20);
            color: #FFFFFF;
            text-shadow: 0px 2px 0px rgba(0,18,11,0.34), 2px 6px 0px rgba(115,255,199,0.13);
          }
        }
      }
      .right-part-bottom-right-top {
        display: flex;
        flex-direction: column;
        .seamless-warp {
          margin-top: vh(18);
          overflow: hidden;
        }
        .r_b_item {
          display: flex;
          .r_b_item_left {
            display: flex;
            flex-direction: column;
            align-items: center;
            height: vh(90);
            width: vw(32);
            position: relative;
            .dot {
              height: vh(40);
              width: vh(40);
            }
            .line {
              margin-top: vh(-14);
              height: vh(82);
              width: vh(2);
            }
          }
          .r_b_item_right {
            width: vw(312);
            height: vh(82);
            margin-top: vh(13);
            padding-left: vh(12);
            background-image: url("../../assets/img/cooperative/dk_bg.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            color: #FFFFFF;
            font-size: fontSize(12);
            display: flex;
            .r_b_item_right_left {
              flex: 1;
              width: vw(240); /* 固定宽度 */  
              overflow: hidden; /* 隐藏超出容器的部分 */  
              white-space: nowrap; /* 防止文字换行 */  
              position: relative; /* 为了内部元素能够绝对定位 */  
              .r_b_item_right_left_title {
                font-size: fontSize(14);
                line-height: vh(34);
              }
              .r_b_item_right_left_item {
                height: vh(22);
                line-height: vh(22);
                .r_b_item_right_left_value {
                  color: #20D2A1;
                  font-size: fontSize(14);
                  margin-left: vw(11);
                }
              }
            }
            .r_b_item_right_right {
              width: vw(56);
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              .r_b_item_right_right_font {
                font-size: fontSize(14);
              }
            }
          }
        }
      }
    }
  }

}

.right-part {
  right: 0;
  transition: all 300ms;
  &.right-part-close {
    right: -100%;
    transition: all 300ms;
  }
}

.currency-title {
  width: vw(352);
  height: vh(38);
  flex: none;
  display: flex;
  align-items: center;
  color: #ffffff;
  justify-content: space-between;
  background: url("../../assets/img/home/tittle_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .title {
    margin-top: vh(-4);
    margin-left: vw(40);
    font-weight: bold;
    font-size: fontSize(20);
    color: #FFFFFF;
    text-shadow: 0px 2px 0px rgba(0,18,11,0.34), 2px 6px 0px rgba(115,255,199,0.13);
  }
}



.l_bottom {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  .l_bottom_header {
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("../../assets/img/cooperative/bg_header_zyltj.png") no-repeat;
    background-size: contain;
    margin-bottom: vh(-8);
    .item {
      width: vw(90);
      height: vh(82);
      margin-top: vh(-3);
      color: #FFFFFF;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: fontSize(12);
      font-weight: 400;
      .item-title-box-box {
        position: relative;
      }
      .item-title-box-num {
        position: relative;
        margin-top: vh(-4);
        font-family: DINPro;
        font-size: fontSize(18);
        background: linear-gradient(180deg, #FFFFFF 35%, #03BAFC 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .item-title-box-num::before {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        color: transparent;
        width: 20px;
        height: 20px;
        text-shadow:
          0 0 1px rgba(255,255,255,0.8), /* 第一层阴影：内阴影 */
          0 0 1px rgba(255,255,255,0.8), /* 第二层阴影：稍微外移一点的阴影 */
          0 0 6px rgba(0,128,255,1), /* 第三层阴影 */
          0 0 6px rgba(0,128,255,1); /* 第四层阴影 */
      }
      .item-title-box-num_1 {
        position: absolute;
        margin-top: vh(-4);
        font-family: DINPro;
        font-size: fontSize(18);
        font-weight: 600;
        z-index: 90;
        text-shadow:
          0 0 1px rgba(255,255,255,0.8), /* 第一层阴影：内阴影 */
          0 0 1px rgba(255,255,255,0.8), /* 第二层阴影：稍微外移一点的阴影 */
          0 0 6px rgba(0,128,255,1), /* 第三层阴影 */
          0 0 6px rgba(0,128,255,1); /* 第四层阴影 */
        
      }
      .item-title-box-num_2 {
        position: absolute;
        z-index: 91;
        margin-top: vh(-5);
        font-family: DINPro;
        font-size: fontSize(18);
        font-weight: 600;
        background: linear-gradient(180deg, #FFFFFF 35%, #03BAFC 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .item-title-box-num2 {
        position: relative;
        font-family: DINPro;
        margin-top: vh(-4);
        font-size: fontSize(18);
        background: linear-gradient(180deg, #FFFFFF 35%, #FC7B03 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .item-title-box-num2::before {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        color: transparent;
        width: 20px;
        height: 20px;
        text-shadow:
          0 0 1px rgba(255,255,255,0.8), /* 第一层阴影：内阴影 */
          0 0 1px rgba(255,255,255,0.8), /* 第二层阴影：稍微外移一点的阴影 */
          0 0 6px rgba(255, 145, 0, 0.8), /* 第三层阴影 */
          0 0 6px rgba(255, 145, 0, 0.8); /* 第四层阴影 */
      }
      .item-title-box-num3 {
        position: relative;
        margin-top: vh(-4);
        font-size: fontSize(20);
        font-family: DINPro;
        background: linear-gradient(180deg, #FFFFFF 35%, #03FC98 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .item-title-box-num3::before {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        color: transparent;
        width: 20px;
        height: 20px;
        text-shadow:
          0 0 1px rgba(255,255,255,0.8), /* 第一层阴影：内阴影 */
          0 0 1px rgba(255,255,255,0.8), /* 第二层阴影：稍微外移一点的阴影 */
          0 0 6px rgba(0, 255, 213, 0.8), /* 第三层阴影 */
          0 0 6px rgba(0, 255, 213, 0.8); /* 第四层阴影 */
      }
    }
    .item1 {
      align-items: flex-end;
    }
    .item2 {
      width: vw(146);
    }
    .item3 {
      align-items: flex-start;
    }
  }
  .b_container,
  .seamless-warp {
    overflow: hidden;
  }
  .l_b_item {
    height: vh(50);
    width: vw(352);
    display: flex;
    padding-left: vw(11);
    background: url("../../assets/img/cooperative/bg_zyltj.png") no-repeat left bottom;
    background-size: 100%;
    border-radius: vw(4);
    margin-bottom: vh(3);
    &_left {
      width: vw(27);
      height: vw(43);
      margin-left: vw(32);
      margin-right: vw(7);
      margin-top: vh(6);
    }
    &_div {
      width: vw(30);
      height: vh(29);
      margin-left: vw(32);
      margin-right: vw(7);
      margin-top: vh(14);
      padding-top: vh(4);
      background: url("../../assets/img/cooperative/new_num.png") no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      font-size: fontSize(12);
      color: #FFFFFF;
      text-shadow: 0px 0px 4px #007045;
    }
    &_right {
      width: vw(352); /* 固定宽度 */  
      overflow: hidden; /* 隐藏超出容器的部分 */  
      white-space: nowrap; /* 防止文字换行 */  
      position: relative; /* 为了内部元素能够绝对定位 */  
      .title {
        font-size: fontSize(14);
        color: #FFFFFF;
        position: absolute;  
        top: 0;
        white-space: nowrap;  
      }
      .num {
        top: vh(20);
        position: absolute;  
        margin-top: vh(-2);
        font-family: Furore;
        font-size: fontSize(20);
        .title-num {
          position: relative;
          background: linear-gradient(180deg, #FFFFFF 35%, #BDFFCC 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .title-num::before {
          content: attr(data-content);
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
          color: transparent;
          width: 20px;
          height: 20px;
          text-shadow:
            0 0 1px rgba(255,255,255,0.8), /* 第一层阴影：内阴影 */
            0 0 1px rgba(255,255,255,0.8), /* 第二层阴影：稍微外移一点的阴影 */
            0 0 6px rgba(0, 255, 205, 0.8), /* 第三层阴影 */
            0 0 6px rgba(0, 255, 205, 0.8); /* 第四层阴影 */
        }
        .unit {
          position: relative;
          margin-left: vw(4);
          font-family: Microsoft YaHei;
          font-size: fontSize(14);
          background: linear-gradient(180deg, #FFFFFF 35%, #BDFFCC 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .unit::before {
          content: attr(data-content);
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
          color: transparent;
          width: 20px;
          height: 20px;
          text-shadow:
            0 0 1px rgba(255,255,255,0.8), /* 第一层阴影：内阴影 */
            0 0 1px rgba(255,255,255,0.8), /* 第二层阴影：稍微外移一点的阴影 */
            0 0 6px rgba(0, 255, 205, 0.8), /* 第三层阴影 */
            0 0 6px rgba(0, 255, 205, 0.8); /* 第四层阴影 */
        }
      }
    }
    &_slide_panel {
      height: vh(8);
      background: #034b21;
      border-radius: vw(2);
      margin-top: vh(8);
      display: flex;
      align-items: center;
      .l_b_item_slide {
        height: 100%;
        border-radius: vw(2);
        position: relative;
        display: flex;
        align-items: center;
        &.orange {
          background: linear-gradient(90deg, #4A350A, #D99D25, #FFE0A3);
        }
        &.yellow {
          background: linear-gradient(90deg, #494A0A, #D6D925, #FDFFA3);
        }
        &.blue {
          background: linear-gradient(90deg, #0A414A, #25C1D9, #A3F3FF);
        }
        &.green {
          background: linear-gradient(90deg, #0A4A32, #25D997, #A3FFDD);
        }
      }
    }
  } 
  .left_work_select {
    position: absolute;
    bottom: vh(-18);
    margin: 0 auto;
    padding-right: vw(80);
    margin-top: vh(-6);
  }
}

.chart_info {
  margin-top: vh(12);
  width: 100%;
  display: flex;
  flex: 1;
  .info_panel {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    padding-top: vh(38);
    flex: 1;
    .month_select {
      position: absolute;
      top: vh(10);
      right: vw(10);
    }
    .switch_panel {
      display: flex;
      // width: vw(96);
      // height: vh(28);
      font-size: fontSize(12);
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(167, 213, 157, 1);
      position: absolute;
      top: vh(5);
      left: vw(-194);
      .btn {
        width: vw(78);
        height: vh(31);
        flex: 1;
        background: url("../../assets/img/cooperative/btn_thb.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &.active {
          padding-top: vh(4);
          font-size: fontSize(14);
          color: rgba(242, 186, 65, 1);
          background: url("../../assets/img/cooperative/btn_thb_c.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .i_item {
      font-size: fontSize(14);
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      .i_bottom {
        font-size: fontSize(20);
      }
      &:nth-of-type(2) {
        .i_bottom {
          color: #FFAE0D;
        }
      }
      &:nth-of-type(3) {
        .i_bottom {
          color: #0DFFAA;
        }
      }
      &:nth-of-type(4) {
        .i_center {
          span {
            color: #0DFFAA;
            &.other {
              color: #FFAE0D;
            }
          }
        }
        .i_bottom {
          color: #ffffff;
          .icon {
            display: inline-block;
            width: vw(13);
            height: vh(15);
            background: url("../../assets/images/work/icon_arrow_top.png") no-repeat;
            background-size: 100% 100%;
            &.rotate {
              background: url("../../assets/images/work/icon_arrow_down.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
  }
}

.right-part-bottom-right-bottom {
  display: flex;
  flex-direction:column;
  background: url("../../assets/img/cooperative/bg_thb.png") no-repeat;
  background-position: left bottom;
  background-size: 100%;
}

::v-deep.seamless-warp {
  width: 100%;
  height: calc(100%);
  overflow: hidden;
}

.drc_select-move {
  transform: translate(192%, 0);
}

::v-deep.drc_select {
  width: vw(193);
  height: vh(32);
  background: url("../../assets/images/common/bg_selecte.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 9;
  top: vh(120);
  right: vw(780);
  display: flex;
  align-items: center;
  padding: vh(4) 0 0 0;
  transition: all 300ms;
  &:before {
    content: '合作社来源';
    position: absolute;
    left: vw(16);
    top: vh(6);
    width: vw(80);
    height: vh(17);
    margin-left: vw(20);
    font-weight: bold;
    font-size: fontSize(14);
    color: #D7FFE0;
  }
  .work_select {
    padding: 0 vw(10) 0 0;
    .el-input__inner {
      padding: 0 vw(10) 0 vw(38);
      text-align: right;
      color: #FFFFFF;
    }
  }
  &.right_fold_close {
    right: -100%;
    transition: all 300ms;
  }
}

.page_fold_panel {
  .right_fold {
    position: fixed;
    z-index: 9;
    top: vh(534);
    right: vw(5);
    cursor: pointer;
    transition: all 300ms;
    .open,.close {
      width: vw(25);
      height: vh(59);
    }
    &.right_fold_close {
      right: vw(0);
      transition: all 300ms;
    }
  }
}


.title-animation {
  animation: scroll 6s linear infinite; /* 动画名称、持续时间、动画速度曲线、是否循环 */  
}

@keyframes scroll {  
  from {  
    transform: translateX(50%); /* 从右边开始 */  
  }  
  to {  
    transform: translateX(-100%); /* 滚动到左边，然后由于无限循环，会从右边重新开始 */  
  }  
}  
</style>
